import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IDeleteTablesParams {
  ids: string[];
}

export class DeleteTablesRequest extends Request<IDeleteTablesParams, IResult> {
  constructor(params: IDeleteTablesParams) {
    super('deleteTables', params);
  }
}
